import { render, staticRenderFns } from "./新闻中心.vue?vue&type=template&id=0f838014&scoped=true"
import script from "./新闻中心.vue?vue&type=script&lang=js"
export * from "./新闻中心.vue?vue&type=script&lang=js"
import style0 from "./新闻中心.vue?vue&type=style&index=0&id=0f838014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f838014",
  null
  
)

export default component.exports